import type { URLAndS3Object } from "@/lib/aws-amplify/storage";
import { getURL } from "@/lib/aws-amplify/storage";
import type { S3Object } from "@/lib/gql/__generated__/graphql";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

export const convertMainKeyVisualIntoUrlAndS3Object = (mainKeyVisual: S3Object): URLAndS3Object => {
	if (!mainKeyVisual.bucket || !mainKeyVisual.key) {
		return DUMMY_IMAGE;
	}

	return {
		url: getURL(mainKeyVisual),
		s3Object: mainKeyVisual,
	};
};

export const convertKeyVisualsIntoUrlAndS3Object = (keyVisuals: S3Object[] | null | undefined): URLAndS3Object[] => {
	if (!keyVisuals?.length) {
		return [];
	}

	return keyVisuals.map((keyVisual) => {
		return convertMainKeyVisualIntoUrlAndS3Object(keyVisual);
	});
};

export const convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour = (
	requiredPrepMillisecond: number,
): {
	requiredPrepMillisecondBeforeDate: number;
	requiredPrepMillisecondBeforeHour: number;
} => {
	const requiredPrepMillisecondBeforeDate = Math.floor(requiredPrepMillisecond / (24 * 60 * 60 * 1000)) || 0;
	const requiredPrepMillisecondBeforeHour =
		24 - Math.round(requiredPrepMillisecond % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000) || 0;

	return {
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
	};
};

export const convertRequiredPrepMillisecondBeforeDateAndHourIntoRequiredPrepMillisecond = ({
	requiredPrepMillisecondBeforeDate,
	requiredPrepMillisecondBeforeHour,
}: {
	requiredPrepMillisecondBeforeDate: number;
	requiredPrepMillisecondBeforeHour: number;
}): number => {
	const requiredDate = requiredPrepMillisecondBeforeDate * 24 * 60 * 60 * 1000;
	const requiredHour = (24 - requiredPrepMillisecondBeforeHour) * 60 * 60 * 1000;

	return requiredDate + requiredHour;
};
